import classNames from 'classnames';
import React, { type FC } from 'react';

import { motion } from 'framer-motion';
import {
    ACCORDION_SECTION_CONTAINER_ID,
    CLUBBED_SECTION_MARGIN_TOP,
    COLLAPSED_SECTION_ANIMATION_DURATION_MS,
} from '../constants';
import styles from './AccordionPanel.module.scss';
import CollapsibleContainer from './CollapsibleContainer/CollapsibleContainer';
import Header from './Header/Header';

type AccordionPanelProps = {
    children: React.ReactNode;
    className?: string;
    collapsibleContainerClassName?: string;
    displayDateTime?: string;
    error?: boolean;
    errorText?: string;
    icon: React.ReactNode;
    isAppRebrandActive: boolean;
    isExpanded: boolean;
    onClick: () => void;
    shouldClubAccordionDateAndTimeSections?: boolean;
    title: string;
};

export const AccordionPanel: FC<AccordionPanelProps> = ({
    children,
    className,
    collapsibleContainerClassName,
    displayDateTime,
    error,
    errorText,
    icon,
    isAppRebrandActive,
    isExpanded,
    onClick,
    shouldClubAccordionDateAndTimeSections = false,
    title,
}) => {
    const marginTop = shouldClubAccordionDateAndTimeSections
        ? CLUBBED_SECTION_MARGIN_TOP
        : 0;
    return (
        <motion.div
            data-section-container-id={ACCORDION_SECTION_CONTAINER_ID}
            className={classNames(styles.accordionContainer, className)}
            initial={{
                marginTop,
            }}
            animate={{
                marginTop,
            }}
            transition={{
                duration: COLLAPSED_SECTION_ANIMATION_DURATION_MS / 1000, // convert to seconds
                ease: 'easeInOut',
            }}
        >
            <Header
                error={error}
                errorText={errorText}
                icon={icon}
                isAppRebrandActive={isAppRebrandActive}
                isClubbed={shouldClubAccordionDateAndTimeSections}
                isExpanded={isExpanded}
                onClick={onClick}
                text={displayDateTime ?? ''}
                title={title}
            />
            <CollapsibleContainer
                isExpanded={isExpanded}
                className={collapsibleContainerClassName}
            >
                {children}
            </CollapsibleContainer>
        </motion.div>
    );
};
